
const page = document.querySelector('body.contact-page');


if (page) {
  window.mapboxgl.accessToken = 'pk.eyJ1Ijoid2ViLWlkZWEiLCJhIjoiY2t2bDJ0NHdqMGs4ejJvdWdlYXE1YjZ0aSJ9.lrlmBGB9vIh4wlIYQFUFnQ';
  let map = new window.mapboxgl.Map({
    container: 'map', // container ID
    style: 'mapbox://styles/mapbox/light-v10/', // style URL
    center: [6.174171658679305, 49.114167326908785], // starting position [lng, lat]
    zoom: 9 // starting zoom
  });


  new window.mapboxgl.Marker({ color: 'black', rotation: 0 })
    .setLngLat([6.174171658679305, 49.114167326908785])
    .addTo(map);
}


// WEBPACK FOOTER //
// ./scripts/modules/map.js